import {ButtonCellEditor} from "./ButtonCellEditor";

export class ColumnButtonsEditor {
    _cellsEditors: ButtonCellEditor[];

    constructor() {
        this._cellsEditors = [];
    }
}